export const ADDRESS: string = 'ADDRESS'
export const FULL_ADDRESS: string = 'FULL_ADDRESS'
export const SELECT_JOB_CATEGORY: string = 'SELECT_JOB_CATEGORY'
export const ADD_COMMENT: string = 'ADD_COMMENT'
export const FUTURE_DATE_FROM: string = 'FUTURE_DATE_FROM'
export const FUTURE_DATE_TO: string = 'FUTURE_DATE_TO'
export const JOB_ITEMS: string = 'JOB_ITEMS'
export const COORDINATES: string = 'COORDINATES'
export const ITEMSOUTSIDE: string = 'ITEMSOUTSIDE'
export const ITEMSINSIDE: string = 'ITEMSINSIDE'
export const PUBLISHED_JOB_PARAMS: string = 'PUBLISHED_JOB_PARAMS'
export const AMOUNT: string = 'AMOUNT'
export const MSAID: string = 'MSAID'
export const IS_ELEVATOR_NEEDED: string = 'IS_ELEVATOR_NEEDED'
export const ARE_STAIRS_NEEDED: string = 'ARE_STAIRS_NEEDED'
export const ATTACHMENTS: string = 'ATTACHMENTS'
export const JOB_CATEGORIES: string = 'JOB_CATEGORIES'
export const SELECTED_JOB_CATEGORY: string = 'SELECTED_JOB_CATEGORY'
export const SUB_CATEGORIES: string = 'SUB_CATEGORIES'
export const TIME: string = 'TIME'
export const JOB_ID: string = 'JOB_ID'
export const STATUS: string = 'STATUS'
export const REMOVE_JOB_DETAILS = 'REMOVE_JOB_DETAILS'
export const CURRENT_LOCATION: string = 'CURRENT_LOCATION'
export const ZIPCODE: string = 'ZIPCODE'
export const ADDITIONAL_ITEM: string = 'ADDITIONAL_ITEM'
export const TIME_MARKS: string = 'TIME_MARKS'
export const APARTMENT_NUMBER: string = 'APARTMENT_NUMBER'
export const IMAGES_MAX_NUMBER: number = 10
export const REMOVE_ALL_IMAGES: string = 'REMOVE_ALL_IMAGES'
export const RESET_CHECKBOXES: string = 'RESET_CHECKBOXES'
export const STATUS_CHANGED_ON_WEB: string = 'STATUS_CHANGED_ON_WEB'
export const SAVE_TEXTAREA_HEIGHT: string = 'SAVE_TEXTAREA_HEIGHT'
export const COMPLIMENTS_NUMBER: string = 'COMPLIMENTS_NUMBER'
export const SET_PROVIDER_ID: string = 'SET_PROVIDER_ID'
export const RESCHEDULE: string = 'RESCHEDULE'
export const SLOTS: string = 'SLOTS'
export const CHIPS: string = 'CHIPS'
export const JOB_TIME_INFO: string = 'JOB_TIME_INFO'
export const SET_BIDS: string = 'SET_BIDS'
export const REPOST_JOB: string = 'REPOST_JOB'
export const ORIGINATED_FROM: string = 'ORIGINATED_FROM'
export const JOB_REQUEST_ID: string = 'JOB_REQUEST_ID'



// WEBPACK FOOTER //
// ./src/constants/jobDetails-constants.ts